import { render } from "./PaymentHistory.vue?vue&type=template&id=671d2912&scoped=true&ts=true"
import script from "./PaymentHistory.vue?vue&type=script&lang=ts"
export * from "./PaymentHistory.vue?vue&type=script&lang=ts"

import "./PaymentHistory.vue?vue&type=style&index=0&id=671d2912&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671d2912"]])

export default __exports__